import { map, catchError, publishLast, refCount } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';
import { ApiService } from './../api/api.service';
import { Injectable } from '@angular/core';
import { IAccount, ILogin } from './../../models/account.interface';
import { Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { environment } from '../../environments/environment';
import { AppLoadService } from '../app-load.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private baseUrl: string;
  private siteUrl: string;
  private redirectEnpoint: string;
  private programTypeCodeOptionSet: string;
  private isProgramCeaBb: boolean;

  constructor(
      private http: ApiService,
      private locationStrategy: LocationStrategy,
      private appLoadService: AppLoadService,
      private router: Router) {

    const settings = appLoadService.readEnvironSettings();
    
    this.baseUrl = settings.uriApi;


    if (window['spaBaseUrl']) {
      this.siteUrl = window['spaBaseUrl'];
    } else {
      const baseurl = window.location.origin;
      this.siteUrl = `${baseurl}${this.locationStrategy.getBaseHref()}`;
    }
    if (this.siteUrl.slice(-1) === '/') {
      this.siteUrl = this.siteUrl.slice(0, -1);
    }

    if (window['ebbApi']) {
      this.redirectEnpoint = `${encodeURIComponent(this.siteUrl+'/register/login')}`
    } else {
      this.redirectEnpoint = `${encodeURIComponent('http://localhost:4200/register/login')}`;
    }

    this.isProgramCeaBb = settings.ProgramIsCeaBb
  }

  public sendVerifyEmail(): Observable<any> {
    return this.http.post(`/Authenticate/setVerifyEmailForGuest`, { })
      .pipe(
        map(result => result as JSON)
      );
  }

  public completeRedirect(redirectEndpoint:string): Observable<any> {
    let endpoint = this.redirectEnpoint;
    if(redirectEndpoint){
      endpoint = this.siteUrl + redirectEndpoint;
    }
    return of(endpoint);
  }

  public loginGuest(guestInfo: ILogin, redirectEndpoint:string): Observable<any> {

    let url = `/Authenticate/loginGuest?email=${encodeURIComponent(guestInfo.email)}` +
    `&firstName=${encodeURIComponent(guestInfo.firstName)}&lastName=${encodeURIComponent(guestInfo.lastName)}` +
    `&nonce=${encodeURIComponent(guestInfo.nonce)}`

    if(redirectEndpoint){
      url += `&redirectEndpoint=${encodeURIComponent(this.siteUrl + redirectEndpoint)}&=useCeaPolicy=${this.isProgramCeaBb}`+
                `&b2cRedirectEndpoint=${encodeURIComponent(this.siteUrl)}`;
      window.location.href = this.baseUrl + url;
      return of(false);
    }

    return this.http
    .get(url)
      .pipe(
        map(data => data as ILogin),
        catchError(err => throwError(err)),
        publishLast(),
        refCount()
      );
  }

  public logout(redirectEndpoint:string): Observable<any> {
    let endpoint = this.redirectEnpoint;
    if(redirectEndpoint){
      endpoint = this.siteUrl + redirectEndpoint;
    }
    endpoint = encodeURIComponent(endpoint);
    return of(`${this.baseUrl}/Authenticate/logout?redirectEndpoint=${endpoint}`);
  }

  public createAccountFromGuest(userData: IAccount): Observable<any> {
    return this.http.post(`/Authenticate/createAccountFromGuest`, userData)
      .pipe(
        map(result => result as JSON)
      );
  }

  public changeEmailForUser(userData: IAccount): Observable<any> {
    return this.http.post(`/Authenticate/changeEmailForUser`, userData)
      .pipe(
        map(result => result as JSON)
      );
  }

  public sendToB2c(redirectEndpoint: string, loginHint: string, useCeaPolicy: string): string {
    const nonce: string = Math.random().toString(36).substring(2, 4) + Math.random().toString(36).substring(2, 4);
    const returnUrl = window['ebbApi'] ? this.siteUrl : 'http://localhost:4200';

    if(useCeaPolicy) {
      return `${this.baseUrl}/Authenticate/login?nonce=${nonce}&redirect=true&redirectEndpoint=${encodeURIComponent(returnUrl + redirectEndpoint)}&useCeaPolicy=${useCeaPolicy}&loginHint=${encodeURIComponent(loginHint)}`;
    }
    else {
      return `${this.baseUrl}/Authenticate/login?nonce=${nonce}&redirect=true&redirectEndpoint=${encodeURIComponent(returnUrl + redirectEndpoint)}&loginHint=${encodeURIComponent(loginHint)}`;
    }
  }

  public sendToLogout(redirectEndpoint: string) : string {
    const returnUrl = window['ebbApi'] ? this.siteUrl : 'http://localhost:4200';
    const endpoint = encodeURIComponent(returnUrl + redirectEndpoint);

    return `${this.baseUrl}/Authenticate/logout?redirectEndpoint=${endpoint}`;
  }

  public sendToPortal() : string {
    return '../../../../portal';
  }
}
